<template>
  <div class="indexPage">
    <header class="heardController">
      <div @click="$router.push({ name: 'Home' })" class="title">
        云南省建设工程材料及设备信息登记
      </div>
      <div
        v-if="$store.state.token === null"
        @click="$router.push({ name: 'LoginIndex' })"
        class="btn userLogin"
      >
        <img src="../assets/user.png" class="ico" />
        <div class="text">企业登录</div>
      </div>
      <div
        v-else
        @click="$router.push({ name: 'AgentInfo' })"
        class="btn userLogin"
      >
        <img src="../assets/user.png" class="ico" />
        <div class="text">用户中心</div>
      </div>
      <div class="btn adminLogin marginLeft20">
        <img src="../assets/adm.png" class="ico" />
        <div class="text ">
          <a
            href="http://cldjadm.ynbzde.com/admin/index/login"
            class="text-a"
            target="_blank"
            >管理机构登录</a
          >
        </div>
      </div>
    </header>
    <div class="banner">
      通知公告
    </div>

    <div class="soContrileklr">
      <div>
        <el-input
          v-model="keyword"
          @input="getList"
          placeholder="请输入通知公告名称"
          class="input-with-select"
        >
          <el-button
            @click="getList"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </div>
    </div>
    <div class="listController">
      <div class="titleController">
        全部内容
      </div>
      <div v-if="li.length === 0" class="aNewList">
        <div class="title">
          未找到通知公告
        </div>
      </div>
      <div
        @click="
          $router.push({
            query: {
              id: val.id
            },
            name: 'new'
          })
        "
        v-for="(val, ind) in li"
        :key="ind"
        class="aNewList"
      >
        <div class="title">
          {{ val.title }}
        </div>
        <div class="date">{{ val.createtime }}</div>
      </div>
    </div>
    <footer class="footerController marginTop20">
      指导单位 | 云南省住房和城乡建设厅科技与标准定额处
      <div class="footChengkai"></div>
      主办单位 | 云南省工程建设技术经济室
      <div class="footChengkai"></div>
      联系电话 0871-68183040 15887247294 <br />
      技术支持 | 昆明行列科技有限公司 13095322247
      <div class="footChengkai"></div>
      备案号
      <a
        class="icp-num"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        >滇ICP备18001273号-1</a
      >
    </footer>
    <!--下面是飘窗-->
    <Piaochuang
      v-for="(val, ind) in piaochuangList"
      :key="ind"
      :href="val.href"
      :src="val.dom_image"
      :width="val.width"
      :height="val.heigh"
    ></Piaochuang>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import Api from "@/plugins/axios.js";
export default {
  name: "Home",
  data() {
    return {
      keyword: "",
      li: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      const re = await Api.getNewList(this.keyword, 100);
      this.li = re.data;
    }
  }
};
</script>
<style>
.el-table .indexTableLint {
  background-color: #f0f8fa;
}
</style>
<style lang="less">
.indexHeardercController {
  color: rgba(102, 102, 102, 1);
}
</style>
<style lang="less" scoped>
.indexPage {
  background-color: #f7f7f7;
  min-height: 100vh;
}
// 1200 的宽度
.width1200 {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
// 头
.heardController {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0px 60px;
  background-color: #f7f7f7;
  .title {
    font-size: 24px;
    font-weight: 600;
    color: rgba(13, 86, 129, 1);
    opacity: 1;
    flex: 1;
    cursor: pointer;
  }
  .btn {
    padding: 0px 20px;
    width: 150px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    display: flex;
    align-items: center;
    cursor: pointer;
    .ico {
      height: 25px;
      width: 25px;
    }
    .text {
      color: rgba(255, 255, 255, 1);
      margin-left: 16px;
      font-weight: 400;
      font-size: 14px;
    }
    .text-a {
      color: rgba(255, 255, 255, 1);
      text-decoration: none;
    }
  }
  .userLogin {
    background: #00b1ff;
  }
  .adminLogin {
    background: rgba(0, 130, 164, 1);
  }
}
// 幻灯片区域
.banner {
  height: 200px;
  background-image: url(../assets/newsbg.jpg);
  background-size: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 50px;
  color: rgba(255, 255, 255, 1);
  opacity: 1;
  .titleController {
    width: 1200px;
    .title {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      opacity: 1;
    }
    .minitTitle {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 24px;
      color: rgba(255, 255, 255, 1);
      opacity: 1;
    }
  }
}
// 页脚区域
.tabController {
  display: flex;
  justify-content: center;
  .title {
    cursor: pointer;
    margin-left: 66px;
    font-size: 24px;
    font-weight: 600;
    opacity: 1;
    padding-bottom: 2px;
    color: rgba(153, 153, 153, 1);
  }
  .title:first-child {
    margin-left: 0px;
  }
  .act {
    color: rgba(51, 51, 51, 1);
    border-bottom: 2px solid rgba(29, 120, 211, 1);
  }
}
// 内容区域
.mainController {
  width: 1200px;
  background: rgba(255, 255, 255, 1);
  opacity: 1;
  border-radius: 4px;
  margin: auto;
  margin-top: 37px;
  // 搜索框
  .soController {
    height: 80px;
    background: rgba(0, 130, 164, 1);
    opacity: 1;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0px 30px;
    .logo {
      width: 50px;
      height: 50px;
    }
    .textController {
      flex: 1;
      .bigText {
        font-size: 16px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        opacity: 1;
      }
      .miniText {
        width: 240px;
        height: 17px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        opacity: 1;
      }
    }
    // 搜索框
    .soInputController {
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(227, 227, 227, 1);
      opacity: 1;
      border-radius: 6px;
      width: 680px;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0px 22px;
      .soBtn {
        font-size: 24px;
        color: #333333;
      }
      .soInput {
        flex: 1;
        border: 0px;
        font-size: 12px;
      }
    }
  }
  // 表格
  .tableController {
    padding: 0px 31px 51px 31px;
  }
}
// 页脚
.footerController {
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  color: rgba(51, 51, 51, 1);
  opacity: 1;
  .icp-num {
    text-decoration: none;
    color: #333333;
  }
}
// 列表视图
.listController {
  width: 1180px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 0px rgba(233, 233, 233, 1);
  opacity: 1;
  margin: auto;
  margin-top: 20px;
  .titleController {
    padding: 20px 30px;
    font-size: 16px;
    color: rgba(45, 45, 45, 1);
    opacity: 1;
  }
  .aNewList {
    border-top: 1px #e9e9e9 solid;
    display: flex;
    align-items: center;
    padding: 20px 30px;
    cursor: pointer;
    .title {
      flex: 1;
      font-size: 14px;
      font-family: Microsoft YaHei;

      color: rgba(117, 117, 117, 1);
      opacity: 1;
    }
    .date {
      font-size: 14px;
      font-family: Microsoft YaHei;

      color: rgba(117, 117, 117, 1);

      opacity: 1;
    }
  }
}
.soContrileklr {
  width: 570px;
  margin: auto;
  margin-top: 20px;
}
</style>
